// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "section[data-v-64deb78a]{position:absolute;padding:10px;width:300px;z-index:10;background-color:rgba(115,94,80,.85);color:#fff;border-radius:3px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
